module.exports = __webpack_public_path__ + "img/transport_planning.0ad41cb5.jpg";